import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackCarReservationEventData } from './legacy-types';

export const createLegacyTrackCarReservationEvent = (
  vehicle: ElasticVehicle,
  information?: any,
): LegacyTrackCarReservationEventData => {
  const eventData: LegacyTrackCarReservationEventData = {
    eventType: 'conversion',
    conversionType: 'car-reservation',
    item: vehicle,
    information: information,
    pageType: 'product page',
  };

  return eventData;
};

export const useLegacyTrackCarReservation = () => {
  const { track } = useLegacyTracking();

  const trackLegacyCarReservation = useCallback(
    (vehicle: ElasticVehicle, information?: any) => {
      track({
        event: 'conversion',
        data: createLegacyTrackCarReservationEvent(vehicle, information),
      });
    },
    [track],
  );

  return {
    trackLegacyCarReservation,
  };
};
